export enum UnsecuredCreditCommitmentTypeEnum {
  BALLOON_HP = 'Balloon HP',
  BANK = 'Bank',
  BUDGET_REVOLVING_ACCOUNT = 'Budget (revolving account)',
  CHARGE_CARD = 'Charge card',
  COMBINED_CREDIT_ACCOUNT = 'Combined Credit Account',
  CONSOLIDATED_DEBT = 'Consolidated Debt',
  CREDIT_CARD_STORE_CARD = 'Credit card / Store card',
  CREDIT_SALE_FIXED_TERM = 'Credit sale fixed term',
  CURRENT_ACCOUNTS = 'Current accounts',
  FINANCE_LEASE = 'Finance lease',
  FIXED_TERM_DEFERRED_PAYMENT = 'Fixed term deferred payment',
  HIRE_PURCHASE_CONDITIONAL_SALE = 'Hire purchase/Conditional sale',
  HOME_CREDIT = 'Home Credit',
  MAIL_ORDER = 'Mail Order',
  OPERATING_LEASE = 'Operating lease',
  PAY_DAY_LOANS = 'Pay Day Loans',
  RENTAL_TV_BROWN_AND_WHITE_GOODS = 'Rental (TV, brown and white goods)',
  SERVICE_CHARGE = 'Service Charge',
  STORE_CARD = 'Store Card',
  UNSECURED_LOAN_PERSONAL_LOANS_ETC = 'Unsecured loan (personal loans etc)',
  VARIABLE_SUBSCRIPTION = 'Variable subscription'
}
